<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم تحویل دستگاه به همکار</h5>

    <br/>
    <br/>

    <ul>
      <li>قبل از اسکن در کادر مربوطه کلیک کنید</li>
      <li>برای بررسی کد اسکن شده می توانید کلیک Enter را فشار دهید</li>
      <li>برای پاک کردن فرم مربوطه می توانید کلیک ESC را فشار دهید</li>

    </ul>

    <br/>
    <br/>

    <form >

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">فروشنده - پیمانکار</label>
          <select class="custom-select" (change)="ReadData_Contractor_Customer()" [(ngModel)]="Selected_Contractor_Id" name="Selected_Contractor_Id" >
            <option value="0">انتخاب کنید</option>
            <option *ngFor="let item of DataList_Contractor" [value]="item.id">{{item.title}}</option>
          </select>
        </div>

        <div class="form-group col-md-4" >
          <label for="exampleInputEmail1">فروشنده - مشتری</label>
          <select class="custom-select" [(ngModel)]="Selected_Contractor_Customer_Id" name="Selected_Contractor_Customer_Id" >
            <option value="0">انتخاب کنید</option>
            <option *ngFor="let item of DataList_Contractor_Customer" [value]="item.id">{{item.title}}</option>
          </select>
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> موضوع نامه </label>
          <select class="custom-select" (change)="SubjectLetter_Change()" [(ngModel)]="SubjectLetter_Id" name="SubjectLetter_Id">
            <option value="0">انتخاب کنید</option>
            <option *ngFor="let item of DataList_SubjectLetter" [value]="item.id">{{item.title}}</option>
          </select>
        </div>

      </div>


      <div class="row" >
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> قبل از اسکن QR Code در کادر پایین کلیک کنید <i class="fa fa-arrow-down"></i>
          </label>
          <input #QRCodeInputDownload type="text" (keyup.enter)="QRCodeInputDownload_Enter()" (keyup.esc)="QRCodeInputDownload_Esc()"
            style="font-family: Arial, Helvetica, sans-serif;background-color: #dfdddd;" class="form-control EnglishClm"
            placeholder="اینجا کلیک کنید ...">
          <p [hidden]="!Procssing"> لطفا صبر نمائید ... <i class="fa fa-spin fa-refresh"></i> </p>

        </div>
      </div>

      <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />

      <button *ngIf="!Procssing && !FormSubmitted" (click)="QRCodeChangeDownload()" type="button" [disabled]="Info_Download_List.length==0 || Selected_Contractor_Customer_Id=='0' || SubjectLetter_Id=='0'" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت ورود دستگاه های اسکن شده </button>

      <button *ngIf="!Procssing && !FormSubmitted" (click)="QRCodeInputDownload_Enter()" type="button"
      class="btn btn-info" style="margin-left: 5px;"><i
       class="fa  fa-plus-circle"></i> بررسی شناسه دستگاه </button>

      <button *ngIf="!Procssing && FormSubmitted" (click)="ResetForm()" type="button"  class="btn btn-danger" style="margin-left: 5px;"><i class="fa  fa-recycle"></i> شروع مججد </button>

      <button routerLink="/LabDownloadUploadDevice" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> بازگشت </button>
    </form>

    <br/>
    <br/>

    <div class="row" *ngIf="Info_Download_List.length>0">
      <div class="form-group col-md-12">
        <div class="table-responsive">
          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>عنوان دستگاه</th>
                <th>کد دستگاه</th>
                <th>سریال دستگاه</th>
                <th *ngIf="!FormSubmitted">توضیحات کاربر</th>
                <th *ngIf="!FormSubmitted">QR Code</th>
                <th *ngIf="FormSubmitted">پیغام سیستم</th>
                <th>امکانات</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of Info_Download_List">
                <td>{{Info_Download_List.indexOf(item)+1}}</td>
                <td>{{item.userDsc}}</td>
                <td>{{item.code}}</td>
                <td>{{item.title}}</td>
                <td *ngIf="item.id==0">
                  <input type="text" class="form-control" [(ngModel)]="item.userDsc" placeholder="اینجا تایپ نمائید ..." />
                </td>

                <td *ngIf="item.id==0">{{item.dsc}}</td>
                <td *ngIf="item.id>0" style="color: green;">{{item.dsc}}</td>
                <td *ngIf="item.id<0" style="color: red;">{{item.dsc}}</td>
                <td>
                  <button  *ngIf="!FormSubmitted" (click)="Info_Download_Remove(Info_Download_List.indexOf(item))" class="btn btn-danger"><i class="fa fa-remove"></i> حذف </button>
                </td>

              </tr>
            </tbody>
          </table>
       </div>
      </div>
    </div>


    <a *ngFor="let item of Info_Download_List_Letter_Id" href="{{PrintURl}}{{item}}" target="_blank"
      style="margin-left: 5px;"> <button type="button" class="btn btn-danger"><i class="fa fa-file-pdf-o"></i>
        PDF شماره نامه {{item}}
      </button> </a>


  </div>
</div>
